const tangjunInfo = {
    namespaced: true,
    state : {
        tangjunNm : '코끼리탕전실',
        tangjunTelNum : '0269521541',
        tangjunPhoneNum : '',
        tangjunPost : '07590',
        tangjunAddr : '서울시 강서구 화곡로63길 93',
        tangjunAddrDtl : '2층 1호 코끼리 원외탕전'
    },
    getters: {
        getTangjunNm (state) {
            return state.tangjunNm
        },
        getTangjunTelNum (state) {
            return state.tangjunTelNum
        },
        getTangjunPhoneNum (state) {
            return state.tangjunPhoneNum
        },
        getTangjunPost (state) {
            return state.tangjunPost
        },
        getTangjunAddr (state) {
            return state.tangjunAddr
        },
        getTangjunAddrDtl (state) {
            return state.tangjunAddrDtl
        }
    },
    mutations: {
        
    },
    actions: {
        
    }
}

export default tangjunInfo